<template>
  <section class="section3-container content-container">
    <div class="pc-content">
      <div class="title-wrapper">
        <h1>{{ $t("home.s3.h1") }}</h1>
        <h2>{{ $t("home.s3.h2") }}</h2>
      </div>
      <div class="content-wrapper">
        <div class="section3-part1-bg">
          <div class="section3-part1-content">
            <div class="number-item">
              <span class="number">73</span>
              <span class="unit">{{ $t("home.s3.number") }}</span>
              <p class="intro">
                {{ $t("home.s3.t1") }}
              </p>
            </div>
            <div class="number-item">
              <span class="number">971</span>
              <span class="unit">{{ $t("home.s3.number") }}</span>
              <p class="intro">
                {{ $t("home.s3.t2") }}
              </p>
            </div>
            <div class="number-item">
              <span class="number">1100</span>
              <span class="unit">{{ $t("home.s3.number") }}</span>
              <p class="intro">
                {{ $t("home.s3.t3") }}
              </p>
            </div>
          </div>
          <!-- <a-button class="exper-btn">
            网络概况
            <a-icon type="arrow-right" />
          </a-button> -->
          <myButton
            class="net-button"
            custom-type="link"
            href="https://scan.lambda.im"
          >
            {{ $t("home.s3.btn") }}
          </myButton>
        </div>
        <div class="section3-part2-bg">
          <div class="section3-part2-content">
            <div class="img-wrapper">
              <img
                src="../../../assets/home/section3-img@1x.png"
                alt=""
              >
            </div>
            <div class="number-content">
              <span class="number">640</span>
              <span class="unit">PB</span>
              <p class="intro">
                {{ $t("home.s3.t4") }} 640PB
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mobile-content">
      <div class="title-wrapper">
        <h1>{{ $t("home.s3.h1") }}</h1>
        <h2>{{ $t("home.s3.h2") }}</h2>
      </div>
      <div class="content-wrapper">
        <div class="section3-part1-bg">
          <div class="section3-part1-content">
            <div class="number-item">
              <span class="number">73</span>
              <span class="unit">{{ $t("home.s3.number") }}</span>
              <p class="intro">
                {{ $t("home.s3.t1") }}
              </p>
            </div>
            <div class="number-item">
              <span class="number">971</span>
              <span class="unit">{{ $t("home.s3.number") }}</span>
              <p class="intro">
                {{ $t("home.s3.t2") }}
              </p>
            </div>
            <div class="number-item">
              <span class="number">1100</span>
              <span class="unit">{{ $t("home.s3.number") }}</span>
              <p class="intro">
                {{ $t("home.s3.t3") }}
              </p>
            </div>
          </div>
        </div>
        <div class="section3-part2-bg">
          <div class="section3-part2-content">
            <div class="img-wrapper">
              <img
                src="../../../assets/home/section3-img@1x.png"
                alt=""
              >
            </div>
            <div class="number-content">
              <span class="number">640</span>
              <span class="unit">PB</span>
              <p class="intro">
                {{ $t("home.s3.t4") }} 640PB
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  components: {
    myButton: () => import("@/components/MyButton.vue")
  }
};
</script>

<style lang="less" scoped>
.section3-container {
  margin-top: 100px;
}
@media (max-width: 500px) {
  .pc-content {
    display: none;
  }
  .mobile-content {
    display: block;
    .title-wrapper {
      margin-bottom: 20px;
      h1 {
        text-align: center;
        font-size: 18px;
        font-family: PingFangHK-Medium, PingFangHK;
        font-weight: 600;
        color: rgba(38, 38, 38, 1);
        line-height: 25px;
      }
      h2 {
        text-align: center;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(38, 38, 38, 1);
        line-height: 22px;
      }
    }
    .content-wrapper {
      margin-bottom: 60px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      flex-wrap: wrap;
      .section3-part1-bg {
        position: relative;
        width: 96%;
        height: 232px;
        background-image: url("../../../assets/home/mobile-map.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        .section3-part1-content {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          .number-item {
            margin-top: 88px;
            width: 30%;
            .number {
              font-size: 30px;
              font-family: DINAlternate-Bold, DINAlternate;
              font-weight: bold;
              color: rgba(63, 74, 225, 1);
              line-height: 35px;
            }
            .unit {
              font-size: 16px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: rgba(63, 74, 225, 1);
              line-height: 22px;
            }
            .intro {
              font-size: 14px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: rgba(38, 38, 38, 1);
              line-height: 20px;
            }
          }
        }
      }
      .section3-part2-bg {
        margin-top: -136px;
        width: 100%;
        height: 305px;
        background-image: url("../../../assets/home/Rectangle 2.png");
        background-size: 304px 305px;
        background-position: 66% 66%;
        background-repeat: no-repeat;
        .section3-part2-content {
          position: relative;
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          .img-wrapper {
            position: absolute;
            top: 100px;
            left: 30px;
            img {
              width: 100px;
              height: 100px;
            }
          }
          .number-content {
            position: absolute;
            top: 113px;
            right: 0px;
            .number {
              font-size: 50px;
              font-family: DINAlternate-Bold, DINAlternate;
              font-weight: bold;
              color: rgba(63, 74, 225, 1);
              line-height: 23px;
            }
            .unit {
              font-size: 20px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: rgba(63, 74, 225, 1);
              line-height: 28px;
            }
            .intro {
              margin-top: 10px;
              font-size: 18px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: rgba(38, 38, 38, 1);
              line-height: 25px;
            }
          }
        }
      }
    }
  }
}

@media (min-width: 501px) {
  .pc-content {
    display: block;
    .title-wrapper {
      h1 {
        font-size: 34px;
        font-family: PingFangHK-Medium, PingFangHK;
        font-weight: 500;
        color: rgba(38, 38, 38, 1);
        line-height: 48px;
      }
      h2 {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(38, 38, 38, 1);
        line-height: 28px;
      }
    }
    .content-wrapper {
      margin-bottom: 60px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      .section3-part1-bg {
        position: relative;
        width: 60%;
        height: 455px;
        background-image: url("../../../assets/home/pc-map.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        .section3-part1-content {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          .number-item {
            margin-top: 88px;
            width: 30%;
            .number {
              font-size: 50px;
              font-family: DINAlternate-Bold, DINAlternate;
              font-weight: bold;
              color: #3f4ae1;
              line-height: 58px;
            }
            .unit {
              font-size: 16px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: rgba(63, 74, 225, 1);
              line-height: 22px;
            }
            .intro {
              font-size: 18px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 600;
              color: rgba(38, 38, 38, 1);
              line-height: 25px;
            }
          }
        }
        .net-button {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translateX(-50%);
        }
      }
      .section3-part2-bg {
        margin-bottom: 50px;
        width: 40%;
        background-image: url("../../../assets/home/Rectangle 2@2x.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        .section3-part2-content {
          position: relative;
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          .img-wrapper {
            position: absolute;
            top: 50px;
          }
          .number-content {
            position: absolute;
            top: 80px;
            left: 168px;
            .number {
              font-size: 80px;
              font-family: DINAlternate-Bold, DINAlternate;
              font-weight: bold;
              color: rgba(63, 74, 225, 1);
              line-height: 23px;
            }
            .unit {
              font-size: 30px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: rgba(63, 74, 225, 1);
              line-height: 42px;
            }
            .intro {
              margin-top: 10px;
              font-size: 20px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 600;
              color: rgba(38, 38, 38, 1);
              line-height: 28px;
            }
          }
        }
      }
    }
  }
  .mobile-content {
    display: none;
  }
}
</style>
